module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"update-order-source":"Update Order Source","create-order-source":"Create Order Source","auth-token":"Auth Token","api-key":"API Key","merchant-id":"Merchant ID","marketplace":"Marketplace","store-url":"Store URL","shop-name":"Shop Name","shop":"Shop","consumer-key":"Consumer Key","consumer-secret":"Consumer Secret","secret-key":"Secret Key"}}')
  delete Component.options._Ctor
}
